import type { ApprovalChain } from '../approval-chain.model';

export const BOND_REGISTRATION_CHAIN: ApprovalChain = {
  id: 'bond-registration',
  label: 'Bond Registration',
  applicationTypes: ['BOND_REGISTRATION'],
  steps: [
    { role: 'MEMBER_ADMIN', action: 'Recommend', from: ['SUBMITTED', 'RESUBMITTED', 'FIRST_BANK_USER_APPROVED'], to: 'LAW_FIRM_APPROVED' },
    { role: 'CONVEYANCER', action: 'Recommend', from: ['LAW_FIRM_APPROVED'], to: 'CONVEYANCER_APPROVED' },
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'PENDING_REVIEW', 'RESUBMITTED', 'CONVEYANCER_APPROVED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
